export class Countdown {
	/*
	 * Init the handler
	 */
	constructor() {
		const countdown = document.querySelectorAll('section.countdown-block');


		countdown.forEach(function (el) {
			el.querySelector('li.countdown-block__list-item--weeks').style.display = 'none';

			//Setup
			const second = 1000,
				minute = second * 60,
				hour = minute * 60,
				day = hour * 24;

			//User selected date
			const inputDate = el.getAttribute('data-countdown'),
				inputDayMonth = inputDate.slice(0, 6),
				inputYear = inputDate.slice(6, -1),
				count_down = inputDayMonth + inputYear;

			//Todays date
			const today = new Date(),
				dd = String(today.getDate()).padStart(2, '0'),
				mm = String(today.getMonth() + 1).padStart(2, '0'),
				yyyy = String(today.getFullYear()).padStart(2, '0'),
				formatToday = mm + '/' + dd + '/' + yyyy;


			//Hide if event has pasted
			if ( formatToday < formatToday ) {
				 el.querySelector('li.countdown-block__list-item--hours').style.display = 'none';
				 el.querySelector('li.countdown-block__list-item--mins').style.display = 'none';
				 el.querySelector('li.countdown-block__list-item--secs').style.display = 'none';
			}

			const countDown = new Date(count_down).getTime(),
				x = setInterval(function () {
					const now = new Date().getTime();
					const distance = countDown - now;
					let days = distance / day + 1;

					// if more than a year split into weeks
					if(days >= 7 || days < 0) {
						(el.querySelector('span.weeks').innerText = Math.abs(Math.floor(days / 7)));

						if(Math.abs(Math.floor(days)) <=7){
							(el.querySelector('span.weeks').innerText = 0);
						}

						days = days % 7;

						el.querySelector('li.countdown-block__list-item--weeks').style.display = 'block';
					}
					// If only one week dont show
					if(Math.floor(days / 7) === -1){
						el.querySelector('li.countdown-block__list-item--weeks').style.display = 'none';
					}

						(el.querySelector('span.days').innerText =   Math.abs(Math.floor(days))),
						(el.querySelector('span.hours').innerText =
							Math.abs(Math.floor((distance % day) / hour))),
						(el.querySelector('span.minutes').innerText =
							Math.abs(Math.floor((distance % hour) / minute))),
						(el.querySelector('span.seconds').innerText =
							Math.abs(Math.floor((distance % minute) / second)));

					//Do something if date is today
					// if (Math.floor(days) == 0) {
					// 	el.classList.add('countdown-block--today')
					// }
					//Do something later when date has pasted
					if (Math.floor(days) < 0) {
						el.classList.add('countdown-block--pasted')
						el.querySelector('li.countdown-block__list-item--weeks').style.display = 'block';
						el.querySelector('li.countdown-block__list-item--hours').style.display = 'none';
						el.querySelector('li.countdown-block__list-item--mins').style.display = 'none';
						el.querySelector('li.countdown-block__list-item--secs').style.display = 'none';
					}
					//seconds
				}, 0);
		});
	}
}
